module.exports = __webpack_public_path__ + "static/infographic-6fb0f017e7e84b22832e1156e0387e53.gif";